import React from 'react';
import PageList from '../../templates/PageList';
import PageSearch from '../../molecules/PageSearch';
import SelectFilter from '../../organisms/SelectFilter';
import { useCreditOperation } from '../../../hooks/useCreditOperation';

const formatDate = (v: string | null) => {
    if (!v) return '-';
    const d = new Date(v.includes('T') ? v : v + 'T00:00:00');
    return isNaN(d.getTime()) ? '-' : d.toLocaleDateString('pt-BR');
};
const formatCurrency = (v: number | null) => v != null ? v.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '-';
const formatRate = (v: number | string | null) => v != null ? `${Number(v).toFixed(4)}%` : '-';

const CreditOperationPageList: React.FC = () => {
    const {
        page, pageSize, fieldSorted, orderSorted, searchTerm,
        contractTypeFilter,
        url, API_KEY,
        pageChanged, pageSizeChanged, pageSorted,
        searchChanged, contractTypeChanged, onFilterClean,
    } = useCreditOperation();

    const renderRows = (rows: any[]) => (
        <>
            {rows.map((row: any, i: number) => (
                <tr key={row.contract_number} className="hover:bg-gray-50">
                    <td className="px-3 py-1 text-xs font-medium">{row.contract_number}</td>
                    <td className="px-3 py-1 text-xs">{row.operation_type || '-'}</td>
                    <td className="px-3 py-1 text-xs">{formatDate(row.issue_date)}</td>
                    <td className="px-3 py-1 text-xs">{formatDate(row.due_date)}</td>
                    <td className="px-3 py-1 text-xs text-right">{formatCurrency(row.nominal_value)}</td>
                    <td className="px-3 py-1 text-xs text-right">{formatCurrency(row.disbursement)}</td>
                    <td className="px-3 py-1 text-xs text-right">{formatRate(row.interest_rate)}</td>
                    <td className="px-3 py-1 text-xs">{row.accrual_period || '-'}</td>
                    <td className="px-3 py-1 text-xs">{row.issuer_name || '-'}</td>
                    <td className="px-3 py-1 text-xs">{row.issuer_tax_id || '-'}</td>
                    <td className="px-3 py-1 text-xs text-center">{row.total_guarantors}</td>
                    <td className="px-3 py-1 text-xs text-center">{row.total_installments}</td>
                </tr>
            ))}
        </>
    );

    return (
        <PageList
            pageTitle="Operações de Crédito"
            url={url}
            fetchHeaders={[
                { key: 'x-api-key', value: API_KEY ?? '' },
                { key: 'Authorization', value: `Bearer ${localStorage.getItem('authToken')}` },
            ]}
            breadcrumb={[{ label: 'Jurídico', url: '#' }, { label: 'Operações de Crédito', url: '#' }]}
            tableHeaders={[
                { id: 'col-contract', field: 'contract_number', title: 'N. Operação', canSort: true, width: '120px' },
                { id: 'col-type', field: 'operation_type', title: 'Tipo', canSort: true, width: '120px' },
                { id: 'col-issue', field: 'issue_date', title: 'Emissão', canSort: true, width: '100px' },
                { id: 'col-due', field: 'due_date', title: 'Vencimento', canSort: true, width: '100px' },
                { id: 'col-nominal', field: 'nominal_value', title: 'Valor Nominal', canSort: true, width: '120px' },
                { id: 'col-disbursement', field: 'disbursement', title: 'Desembolso', canSort: true, width: '120px' },
                { id: 'col-rate', field: 'interest_rate', title: 'Remuneração', canSort: true, width: '110px' },
                { id: 'col-accrual', field: 'accrual_period', title: 'Período Aprop.', canSort: true, width: '120px' },
                { id: 'col-issuer', field: 'issuer_name', title: 'Emitente', canSort: true, width: '160px' },
                { id: 'col-tax', field: 'issuer_tax_id', title: 'Doc. Emitente', canSort: true, width: '130px' },
                { id: 'col-guarantors', field: '', title: 'Avalistas', canSort: false, width: '80px' },
                { id: 'col-installments', field: '', title: 'Parcelas', canSort: false, width: '80px' },
            ]}
            tableFieldSort={fieldSorted as string}
            tableOrderSort={orderSorted as 'ASC' | 'DESC'}
            onTableSort={pageSorted}
            renderRows={renderRows}
            page={Number(page)}
            pageSize={Number(pageSize)}
            onPageChange={pageChanged}
            onItemsPerPageChange={pageSizeChanged}
            defaultBackendHeader={false}
            itemsLabel="operações"
        >
            {{
                filterSlot: (
                    <div className="flex gap-1 items-end">
                        <SelectFilter
                            id="contract-type-filter"
                            label="Tipo"
                            value={contractTypeFilter}
                            onChange={contractTypeChanged}
                            defaultVoidOption={true}
                            defaultLabel="Todos"
                            options={[
                                { value: 'CPR-F', label: 'CPR-F' },
                                { value: 'CPR-F_ESTRUTURADA', label: 'CPR-F Estruturada' },
                                { value: 'CESSAO_CREDITO', label: 'Cessão de Crédito' },
                            ]}
                            className="w-44"
                        />
                        <PageSearch
                            value={searchTerm}
                            label="Buscar por contrato, emitente, documento..."
                            onSearch={searchChanged}
                            filterCleanVisible={true}
                            filterCleanEnabled={Boolean(searchTerm) || Boolean(contractTypeFilter)}
                            onFilterClean={onFilterClean}
                            configureVisible={false}
                            className="flex-1"
                        />
                    </div>
                ),
                controlSlot: null,
            }}
        </PageList>
    );
};

export default CreditOperationPageList;
